module.exports = __webpack_public_path__ + "4a96971e27611f4b7e98648cdb99e4d6.png";